export default "__VITE_PUBLIC_ASSET__dc7f7c97__"